// ForgotPassword.js
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Container, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import PasswordResetRequest from '../../graphql/mutations/PasswordReset';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleReset = async () => {
        setIsLoading(true);
        setError('');
        try {
            PasswordResetRequest.commit({ email }).then(() => {
                setSuccess(t('checkEmailForReset', 'Check your email for reset instructions.'));
                setIsLoading(false);
            })
        } catch (err) {
            console.error('Reset request error:', err);
            setError(t('somethingWentWrong', 'Something went wrong.'));
            setIsLoading(false);
        }
    };

    return (
        <Container maxWidth="lg">
            <Box
                sx={{
                    maxWidth: '400px',
                    margin: '50px auto',
                    padding: 4,
                    bgcolor: 'background.paper',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                }}
            >
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        color: 'primary.main',
                    }}
                >
                    {t('forgotPassword', 'Forgot password?')}
                </Typography>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
                {success && (
                    <Alert severity="success" sx={{ mb: 2 }}>
                        {success}
                    </Alert>
                )}
                <Box component="form" noValidate autoComplete="off">
                    <TextField
                        fullWidth
                        slotProps={{ inputLabel: { shrink: true } }}
                        autoComplete="off"
                        type="email"
                        label={t('email', 'Email')}
                        variant="outlined"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{ mb: 3 }}
                    />
                    <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        disabled={isLoading || email.length === 0}
                        onClick={handleReset}
                        sx={{
                            fontSize: '1rem',
                            padding: '12px 0',
                            textTransform: 'none'
                        }}
                    >
                        {isLoading && <CircularProgress size={20} color="inherit" sx={{ marginRight: '15px' }} />}
                        {t('requestPasswordReset', 'Request Password Reset')}
                    </Button>

                    <Typography variant="body2" sx={{ marginTop: '15px', textAlign: 'right' }}>
                        <Link
                            to="/sign-in"
                            style={{ color: '#80a748', textDecoration: 'none' }}
                            onClick={() => {
                                window.localStorage.clear();
                                window.location.href = '/sign-in';
                            }}
                        >
                            {t('backToSignIn', 'Back to sign in')}
                        </Link>
                    </Typography>
                </Box>
            </Box>
        </Container>
    );
};

export default ForgotPassword;
